import { Map } from "immutable"
import { COLOR_SYSTEM } from "components/design/design-system"
import { typography } from "components/design/typography"
import React from "react"
import styled from "styled-components"

export interface RadioButtonProps {
  /** 자식 노드 */
  children?: React.ReactNode
  /** input 태그 value 속성 값 */
  value: string
  /** 체크 여부 */
  checked: boolean
  /** change event handler */
  onChange: (event?: React.ChangeEvent<HTMLInputElement>) => any
  size: RadioSize
  style?: React.CSSProperties
}
export type RadioSize = "Medium" | "Large"

export const RadioSizeMap = Map<RadioSize, string>({
  Medium: `
        width: 16px;
        height: 16px;
        background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
        border-radius: 50%;
        margin-right: 12px;
        position: relative;
  
        &::after {
          content: "";
          width: 6px;
          height: 6px;
          border-radius: 50%;
          background-color: white;
          position: absolute;
          top: 5px;
          left: 5px;
        }
    `,
  Large: `
        width: 28px;
        height: 28px;
        background-color: ${COLOR_SYSTEM.get("Gray")?.[50]};
        border-radius: 50%;
        margin-right: 12px;
        position: relative;
  
        &::after {
          content: "";
          width: 12px;
          height: 12px;
          border-radius: 50%;
          background-color: white;
          position: absolute;
          top: 8px;
          left: 8px;
        }
    `,
})
export interface RadioButtonWrapperProps {
  checked: boolean
  style?: React.CSSProperties
}

interface RadioProps {
  size: RadioSize
  style?: React.CSSProperties
}

const Radio = styled.div<RadioProps>`
  ${({ size }) => RadioSizeMap.get(size)}
`

const RadioButtonWrapper = styled.label<RadioButtonWrapperProps>`
  display: inline-flex;
  align-items: center;
  color: ${({ checked }) =>
    checked
      ? COLOR_SYSTEM.get("Gray")?.[700]
      : COLOR_SYSTEM.get("Gray")?.[400]};
  ${typography.get("InputMedium")};
  cursor: pointer;

  input {
    display: none;

    &:checked + ${Radio} {
      background-color: ${COLOR_SYSTEM.get("Gray")?.[700]};
    }
  }
  ${({ style }) => style}
`

const RadioButton = ({
  children,
  value,
  checked = false,
  onChange,
  size,
  style
}: RadioButtonProps) => {
  return (
    <RadioButtonWrapper checked={checked} style={style}>
      <input type="radio" value={value} checked={checked} onChange={onChange} />
      <Radio size={size} />
      {children}
    </RadioButtonWrapper>
  )
}

export default RadioButton
